import type { ProviderKind } from "@cmmd-forge/contracts";

/**
 * Model slugs that show a gold "NEW" chip in the model picker list.
 * Add entries as `provider:slug` when you want to highlight freshly shipped
 * models. Ported from t3code's modelPickerModelHighlights — same pattern,
 * adapted for Forge's ProviderKind (no provider instances).
 */
const NEW_MODEL_KEYS = new Set<string>([
  // Example: "claudeAgent:claude-opus-4-7",
]);

export function isModelPickerNewModel(provider: ProviderKind, slug: string): boolean {
  return NEW_MODEL_KEYS.has(`${provider}:${slug}`);
}
